
import { ref } from "vue";
import { updateLog as content } from "../options";
export default {
  setup() {
    const Dialog = ref();
    const close = () => {
      Dialog.value.close();
    };
    const open = () => {
      Dialog.value.open();
    };
    return {
      Dialog,
      close,
      open,
      content
    };
  }
};
